
import axios, { Canceler } from 'axios';
import { ITagType } from '@/interfaces/Tags/ITagType';
import Vue from 'vue'
//import VueCookies from 'vue-cookies';
import { useCookies } from "vue3-cookies";

// default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' }


const clientAPI = axios.create();

clientAPI.defaults.baseURL = process.env.VUE_APP_MYBASE_URL + '/api/'; 
clientAPI.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
clientAPI.defaults.headers.common.Pragma = 'no-cache';
clientAPI.defaults.headers.common.Expires = '0';

export { clientAPI };
export default class API {
    
    public static async isAuthenticated() {
        const { cookies } = useCookies();
        const response = (await clientAPI.get("/user/isauthenticated/")).data;
        //alert(response);
        cookies.set("checkifloggedin", response);
        return response;
        
    }

    public static checkauth() {
        const { cookies } = useCookies();
        const chek = cookies.get("checkifloggedin");
        return chek;
    }
    
    /*public static async getTags(tagvalue: string) {
        const response = (await clientAPI.get('/tags/' + tagvalue)).data;

        if (response.success && response.data == "already available") {
            throw new Error(response.data);
        }
        else if (response.success) {
            return response.data as IBiome[];
        }
        throw new Error('Error getting list');

    }
    public static async getTagByid(tagvalue: string,tagid:number) {
        const response = (await clientAPI.get('/tags/getbyid/' + tagvalue + '/' + tagid)).data;
        if (response.success) {
            return response.data as IBiome;
        }
        throw new Error('Error getting list');

    }
    public static async posttag(tags: any) {      
        const result = (
            await clientAPI.post('/tags/addtags', tags)
        ).data;

        if (result.success) {
            return result.data as IBiome[];
        } else {
            throw new Error(result.errors.join(', '));
        }
    }
    public static async updatetag(tags: any) {
        const result = (
            await clientAPI.post('/tags/edittag/'+tags, tags)
        ).data;

        if (result.success) {
            return result.data as IBiome[];
        } else {
            throw new Error(result.errors.join(', '));
        }
    }
    public static async deletetag(tagvalue:string,tagid: number) {
        try {
            const deleteResult = (await clientAPI.delete('tags/deletetag/' + tagvalue+'/' + tagid)).data;

            return deleteResult.success;
        } catch (e) {
           // throw new Error(e.message);
        }
    }
    public static async getfiles() {
        const response = (await clientAPI.get('/files/allfiles')).data;

        if (response.success && response.data == "already available") {
            throw new Error(response.data);
        }
        else if (response.success) {
            return response.data as IBiome[];
        }
        throw new Error('Error getting list');

    }
    public static async getfilebyid(id:number) {
       
        const response = (await clientAPI.get('/Files/getfilebyid/'+id)).data;

        if (response.success) {
            return response.data as IBiome[];
        } else {
            throw new Error(response.errors.join(', '));
        }
        
    }
    public static async getfileselected(selected: any) {
        console.log(selected)
        const result = (
            await clientAPI.post('/Files/allfiless', selected)
        ).data;

        if (result.success) {
            return result.data as IBiome[];
        } else {
            throw new Error(result.errors.join(', '));
        }

    }
    public static async postfile(files: any) {
        console.log(files)
        const result = (
            await clientAPI.post('/Files/addfiles', files)
        ).data;

        if (result.success) {
            return result.data as IBiome[];
        } else {
            throw new Error(result.errors.join(', '));
        }
    }
    //download file
    public static async downloadFile(fileid: string, fileName: string) {
        console.log(fileid)
        console.log(fileName)
        const formData: FormData = new FormData();
        formData.append('fileid', fileid);
        formData.append('fileName', fileName);
       
        const fileResult = (await clientAPI.post('/Files/DownloadFile', formData, {
            responseType: 'blob',
        }));

        if (fileResult) {
            const blobUrl = window.URL.createObjectURL(new Blob([fileResult.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', fileName); //or any other extension
            link.click();
            setTimeout(() => {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(blobUrl);
            }, 100);
        } else {
            throw new Error("No file found");
        }

    }
    public static async deletefile(fileid: number) {
        try {
            console.log(fileid)
            const deleteResult = (await clientAPI.delete('/Files/deletefile/' + fileid)).data;

            return deleteResult.success;
        } catch (e) {
            // throw new Error(e.message);
        }
    }*/
}